import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MigoAccordionComponent } from './accordion/migo-accordion.component';
import { MigoExpansionPanelComponent } from './expansion-panel/migo-expansion-panel.component';
import { MigoExpansionPanelHeaderComponent } from './expansion-panel-header/migo-expansion-panel-header.component';
import { MigoExpansionPanelContentComponent } from './expansion-panel-content/migo-expansion-panel-content.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [
    MigoAccordionComponent,
    MigoExpansionPanelComponent,
    MigoExpansionPanelHeaderComponent,
    MigoExpansionPanelContentComponent,
  ],
  imports: [CommonModule, MatIconModule, MatButtonModule],
  exports: [
    MigoAccordionComponent,
    MigoExpansionPanelComponent,
    MigoExpansionPanelHeaderComponent,
    MigoExpansionPanelContentComponent,
  ],
})
export class MigoAccordionModule {}
